import React, { useState, useEffect } from "react";
import Api from "../../../../services/api";
import "../../../../assets/css/app/monetization.css";
import "../../../../assets/css/app/release-intel.css";
import {
    Button,
    Form,
    Row,
    Col,
    InputGroup,
    FormControl,
} from "react-bootstrap";
import {
    Collapse,
    Modal,
    Select,
    Space,
    Input,
    DatePicker,
    Button as AntButton,
    Radio,
    Tabs,
    Divider,
    InputNumber
} from "antd";
import moment from "moment";
import dayjs from "dayjs";

import { SaveOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { ColorPicker, Switch } from "antd";
import TableContainer from "../../../../components/TableContainer";

const { RangePicker } = DatePicker;

const analyticsMetrics = [
    { id: "dau", label: "DAU", selected: true },
    { id: "playTime", label: "Play Time", selected: true },
    { id: "sessions", label: "Sessions", selected: true },
    { id: "attributedInstalls", label: "Attributed Installs", selected: true },
    { id: "accAdRevenue", label: "Acc. Ad Revenue", selected: true },
    { id: "accIapRevenue", label: "Acc. IAP Revenue", selected: true },
    { id: "adRevenue", label: "Ad Revenue", selected: true },
    { id: "iapRevenue", label: "IAP Revenue", selected: true },
    { id: "mImpressions", label: "M-Impressions", selected: true },
    { id: "dailyPaidUsers", label: "Daily Paid Users", selected: true },
    { id: "paidRate", label: "Paid Rate", selected: true },
    { id: "ipdau", label: "IPDAU", selected: true },
    { id: "rpdau", label: "RPDAU", selected: true },
    { id: "gpdau", label: "GPDAU", selected: true },
    { id: "ipdeu", label: "IPDEU", selected: true },
    { id: "rpdeu", label: "RPDEU", selected: true },
    { id: "adRpdau", label: "Ad RPDAU", selected: true },
    { id: "iapRpdau", label: "IAP RPDAU", selected: true },
    { id: "advertisingId", label: "AdvertisingID %", selected: true },
    { id: "rpm", label: "RPM", selected: true },
    { id: "accTotalRevenue", label: "Acc. Total Revenue", selected: true },
    { id: "arppu", label: "ARPPU", selected: true },
    { id: "accPurchases", label: "Acc. Purchases", selected: false },
    { id: "purchases", label: "Purchases", selected: false },
];


const adFormatMetrics = [
    { id: "bannerRpm", label: "Banner RPM", selected: true },
    { id: "bannerIpdau", label: "Banner IPDAU", selected: true },
    { id: "bannerRpdau", label: "Banner RPDAU", selected: true },
    { id: "bannerIpdeu", label: "Banner IPDEU", selected: true },
    { id: "bannerRpdeu", label: "Banner Rpdeu", selected: true },

    { id: "interRpm", label: "Inter. RPM", selected: true },
    { id: "interIpdau", label: "Inter. IPDAU", selected: true },
    { id: "interRpdau", label: "Inter. RPDAU", selected: true },
    { id: "interIpdeu", label: "Inter. IPDEU", selected: true },
    { id: "interRpdeu", label: "Inter. Rpdeu", selected: true },

    { id: "appOpenRpm", label: "App Open RPM", selected: true },
    { id: "appOpenIpdau", label: "App Open IPDAU", selected: true },
    { id: "appOpenRpdau", label: "App Open RPDAU", selected: true },
    { id: "appOpenIpdeu", label: "App Open IPDEU", selected: true },
    { id: "appOpenRpdeu", label: "App Open RPDEU", selected: true },

    { id: "rewardRpm", label: "Reward. RPM", selected: true },
    { id: "rewardIpdau", label: "Reward. IPDAU", selected: true },
    { id: "rewardRpdau", label: "Reward. RPDAU", selected: true },
    { id: "rewardIpdeu", label: "Reward. IPDEU", selected: true },
    { id: "rewardRpdeu", label: "Reward. RPDEU", selected: true },

    { id: "nativeRpm", label: "Native. RPM", selected: true },
    { id: "nativeIpdau", label: "Native. IPDAU", selected: true },
    { id: "nativeRpdau", label: "Native. RPDAU", selected: true },
    { id: "nativeIpdeu", label: "Native. IPDEU", selected: true },
    { id: "nativeRpdeu", label: "Native. RPDEU", selected: true },

    { id: "rewardedInterRpm", label: "Rewarded Inter. RPM", selected: true },
    { id: "rewardedInterIpdau", label: "Rewarded Inter. IPDAU", selected: true },
    { id: "rewardedInterRpdau", label: "Rewarded Inter. RPDAU", selected: true },
    { id: "rewardedInterIpdeu", label: "Rewarded Inter. IPDEU", selected: true },
    { id: "rewardedInterRpdeu", label: "Rewarded Inter. RPDEU", selected: true },

    { id: "mrecRpm", label: "MREC RPM", selected: false },
    { id: "mrecIpdau", label: "MREC IPDAU", selected: false },
    { id: "mrecRpdau", label: "MREC RPDAU", selected: false },
    { id: "mrecIpdeu", label: "MREC IPDEU", selected: false },
    { id: "mrecRpdeu", label: "MREC RPDEU", selected: false },

    { id: "audioAdsRpm", label: "Audio Ads RPM", selected: false },
    { id: "audioAdsIpdau", label: "Audio Ads IPDAU", selected: false },
    { id: "audioAdsRpdau", label: "Audio Ads RPDAU", selected: false },
    { id: "audioAdsIpdeu", label: "Audio Ads IPDEU", selected: false },
    { id: "audioAdsRpdeu", label: "Audio Ads RPDEU", selected: false },

    { id: "collapsibleRpm", label: "Collapsible. RPM", selected: false },
    { id: "collapsibleIpdau", label: "Collapsible. IPDAU", selected: false },
    { id: "collapsibleRpdau", label: "Collapsible. RPDAU", selected: false },
    { id: "collapsibleIpdeu", label: "Collapsible. IPDEU", selected: false },
    { id: "collapsibleRpdeu", label: "Collapsible. RPDEU", selected: false },

    { id: "inGameRpm", label: "In-game RPM", selected: false },
    { id: "inGameIpdau", label: "In-game IPDAU", selected: false },
    { id: "inGameRpdau", label: "In-game RPDAU", selected: false },
    { id: "inGameIpdeu", label: "In-game IPDEU", selected: false },
    { id: "inGameRpdeu", label: "In-game RPDEU", selected: false },
];

const MetricButton = ({ metric, onClick }) => {
    if (!metric) {
        return null;
    }

    return (
        <AntButton
            type={metric.selected ? "primary" : "default"}
            className={`metric-btn ${metric.selected ? "selected" : ""}`}
            onClick={() => onClick(metric.id)}
            style={{ width: '100%' }}
        >
            {metric.label}
        </AntButton>
    );
};

const dayOptions = [
    { value: "D0", label: "D0" },
    { value: "D1", label: "D1" },
    { value: "D3", label: "D3" },
    { value: "D7", label: "D7" },
    { value: "D14", label: "D14" },
    { value: "D15", label: "D15" },
    { value: "D30", label: "D30" },
];

const MetricsSection = ({
                            analyticsMetrics,
                            adFormatMetrics,
                            onMetricToggle,
                            rrDays,
                            setRrDays,
                            iapDays,
                            setIapDays,
                            adDays,
                            setAdDays,
                            ltvDays,
                            setLtvDays,
                            onOpenEditModal,
                            customMetrics,
                            setActiveCustomMetric,
                            setAddVisible,
                            onOpenSaveModal
                        }) => {
    const handleRrDaysChange = (selected) => {
        setRrDays(selected || []);
    };

    const handleIapDaysChange = (selected) => {
        setIapDays(selected || []);
    };

    const handleAdDaysChange = (selected) => {
        setAdDays(selected || []);
    };

    const handleLtvDaysChange = (selected) => {
        setLtvDays(selected || []);
    };
    return (
        <div className="metrics-section">
            <div className="metrics-group">
                <h6>Analytics & Attribution:</h6>
                <Row className="mb-4">
                    {analyticsMetrics.map((metric) => (
                        <Col md={2} style={{ marginBottom: "7px" }}>
                            <MetricButton
                                key={metric.id}
                                metric={metric}
                                onClick={onMetricToggle}
                            />
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="metrics-group">
                <h6>Ad Format:</h6>
                <Row className="mb-4">
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpm')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerIpdau')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpdau')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerIpdeu')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpm')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'interIpdau')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpdau')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'interIpdeu')} onClick={onMetricToggle} />
                    </Col>
                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpm')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenIpdau')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpdau')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenIpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpdeu')} onClick={onMetricToggle} />
                    </Col>

                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpm')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameIpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpdau')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameIpdeu')} onClick={onMetricToggle} />
                    </Col>


                    <Col md={2} style={{ marginBottom: "7px" }}>
                        <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpdeu')} onClick={onMetricToggle} />
                    </Col>
                </Row>
            </div>

            <div className="metrics-config">
                {/* Row 1 - Ad Format IPDAU/RPDAU */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>GPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>RPM:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>


                {/* Row 7 - Retention Rate & LTV Metrics */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Retention Rate (RR):</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={rrDays}
                            onChange={handleRrDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>IAP LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={iapDays}
                            onChange={handleIapDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Ad LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={adDays}
                            onChange={handleAdDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={ltvDays}
                            onChange={handleLtvDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 8 - Play Time */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Play Time:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>
            </div>

            <div className="custom-metrics">
                <h6 style={{ fontWeight: 'bold', marginBottom: '16px' }}>Custom Metrics:</h6>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                    {customMetrics.map((m, idx) => (
                        <AntButton
                            key={idx}
                            type={m.active ? "primary" : "default"}
                            style={{
                                minWidth: '160px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '4px 12px',
                                borderRadius: '6px',
                                border: m.active ? 'none' : '1px solid #d9d9d9'
                            }}
                            onClick={() => setActiveCustomMetric(idx)}
                        >
                          <span style={{
                              color: m.active ? '#fff' : '#595959',
                              fontSize: '14px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '120px'
                          }}>
                            {m.label}
                          </span>
                            <EditOutlined
                                style={{
                                    color: m.active ? '#fff' : '#8c8c8c',
                                    fontSize: '12px',
                                    marginLeft: '8px'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onOpenEditModal(idx);
                                }}
                            />
                        </AntButton>
                    ))}
                    <AntButton
                        type="dashed"
                        style={{
                            minWidth: '160px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 12px',
                            borderRadius: '6px',
                            border: '1px dashed #d9d9d9'
                        }}
                        onClick={() => setAddVisible(true)}
                    >
                        <PlusOutlined style={{ fontSize: '12px', marginRight: '4px' }} />
                        Add Metric
                    </AntButton>
                </div>
            </div>
        </div>
    );
};

const FilterForm = ({ onSubmit }) => {
    const [formData, setFormData] = useState({
        reportName: "New Report",
        startDate: moment("2025-08-19"),
        endDate: moment("2025-08-26"),
        country: [],
        appVersion: [],
        baseVersion: "2000_2001_2002",
        appVersionSource: "Attribution Service",
    });


    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const countryOptions = [
        { value: "vn", label: "Vietnam" },
        { value: "us", label: "United States" },
        { value: "jp", label: "Japan" },
        { value: "kr", label: "Korea" },
        { value: "sg", label: "Singapore" },
    ];


    const [saveFilter, setSaveFilter] = useState(false);
    const [value, setValue] = useState(1);

    const onChangeRadio1 = (e) => {
        console.log("checked", e.target.value);
        setValue(e.target.value);
    };

    const [dateType, setDateType] = useState("relative");

    // tính ngày cho absolute
    const today = dayjs();
    const endDate = today.subtract(1, "day"); // hôm qua
    const startDate = endDate.subtract(7, "day"); // lùi 7 ngày
    const absoluteText = `${startDate.format("MMM DD, YYYY")}~${endDate.format(
        "MMM DD, YYYY"
    )}`;


    return (
        <>
            <form onSubmit={handleSubmit}>
                <Row className="mb-4">
                    <Col md={6} >
                        <Select
                            style={{ width: "100%" }}
                            value={formData.reportName}
                            onChange={(v) =>
                                setFormData((prev) => ({ ...prev, reportName: v }))
                            }
                            options={[
                                { value: "New Report", label: "New Report" },
                            ]}
                        />
                    </Col>
                </Row>

                <Row className="mb-4">

                    <Col md={3} >
                        <div className="filter-group">
                            <label>Date range:</label>
                            <RangePicker
                                ranges={{
                                    'This Week': [moment().startOf('week'), moment().endOf('week')],
                                    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                    'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                    'Last 10 Days': [moment().subtract(10, 'days'), moment()],
                                    'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                }}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </Col>
                    <Col md={3} >
                        <div className="filter-group flex-fill">
                            <label>Country:</label>
                            <Select
                                mode="multiple"
                                placeholder="Select country"
                                value={formData.country}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, country: value }))
                                }
                                options={countryOptions}
                                style={{ width: '100%' }}
                                allowClear
                                maxTagCount={1}
                                maxTagTextLength={10}
                            />
                        </div>
                    </Col>

                    <Col md={6} >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "24px" }}>
                            <AntButton
                                type="primary"
                                htmlType="submit"
                                className="run-report-btn"
                                style={{ minWidth: "120px" }}
                            >
                                Run Report
                            </AntButton>
                            <AntButton
                                type="dashed"
                                onClick={() => setSaveFilter(true)}
                            >
                                <SaveOutlined />
                            </AntButton>
                        </div>
                    </Col>
                </Row>
            </form>
            <Modal
                title="Save Report"
                open={saveFilter}
                onOk={() => {
                    console.log("Filter saved!");
                    setSaveFilter(false);
                }}
                onCancel={() => setSaveFilter(false)}
                okText="Save"
                cancelText="Cancel"
            >
                <Row className="mb-4">
                    <Col md={3}>

                        <label>
                            <span style={{ color: '#ff4d4f' }}>*</span> Report Name:
                        </label>
                    </Col>
                    <Col md={9}>
                        <Input
                            placeholder="Enter metric name"
                            style={{ width: '100%' }}
                        />
                    </Col>

                </Row>
                <Row className="mb-4">
                    <Col md={5}>
                        <span style={{ width: 200 }}>This report is available for:</span>
                    </Col>
                    <Col md={7}>
                        <Radio.Group onChange={onChangeRadio1} value={value}>
                            <Radio value={1}>This app only</Radio>
                            <Radio value={2}>All app</Radio>
                        </Radio.Group>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col md={5}>
                        <span style={{ width: 200 }}>Date Range Setting:</span>
                    </Col>
                    <Col md={7}>
                        <Radio.Group
                            value={dateType}
                            onChange={(e) => setDateType(e.target.value)}
                        >
                            <Radio value="relative">Relative</Radio>
                            <Radio value="absolute">Absolute</Radio>
                        </Radio.Group>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col md={3}>
                        <span>Date Range:</span>
                    </Col>
                    <Col md={9}>
                        <b>{dateType === "relative" ? "last 7 to 0 days" : absoluteText}</b>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

function AppMediation() {
    const [analyticsMetricsState, setAnalyticsMetricsState] = useState(analyticsMetrics);
    const [adFormatMetricsState, setAdFormatMetricsState] = useState(adFormatMetrics);
    const [metricsExpanded, setMetricsExpanded] = useState(false);
    const [rrDays, setRrDays] = useState([]);
    const [iapDays, setIapDays] = useState([]);
    const [adDays, setAdDays] = useState([]);
    const [ltvDays, setLtvDays] = useState([]);
    const [customMetrics, setCustomMetrics] = useState([
        { label: "Attributed / Ad Network Installs", active: false },
        { label: "IAP percentage", active: false },
        { label: "Total ROAS", active: false },
    ]);
    const [hasRunReportTop, setHasRunReportTop] = useState(false);
    const [hasRunReportMetrics, setHasRunReportMetrics] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const [addVisible, setAddVisible] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [showMetricDropdown, setShowMetricDropdown] = useState(false);
    const [selectedMetrics, setSelectedMetrics] = useState([]);
    const [numberInput, setNumberInput] = useState('');
    const [showNumberInput, setShowNumberInput] = useState(false);


    const [sortConfig, setSortConfig] = useState({ field: null, direction: null });
    const [showPopup, setShowPopup] = useState(false);
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState({ searchTerm: "", conditions: {}, expandedFields: {} });
    const [columnFilterPopup, setColumnFilterPopup] = useState({ activeColumn: null, position: { top: 0, left: 0 } });
    const columnPopupRef = React.useRef(null);

    const [fields, setFields] = useState([
        { key: "variant", label: "Variant", checked: true },
        { key: "date", label: "Date", checked: true },
        { key: "country", label: "Country", checked: true },
    ]);

    const [filterableColumns] = useState([
        "install_ad_network",
        "ltv_d1_2",
        "ltv_d3",
        "ltv_d7",
        "ltv_d15",
        "ltv_d30",
        "ad_ltv_d1",
        "ad_ltv_d3",
        "ad_ltv_d7",
        "iap_ltv_d1",
        "iap_ltv_d3",
        "iap_ltv_d7",
        "RR_D1",
        "RR_D3",
        "RR_D7",
        "RR_D15",
        "RR_D30",
        "acc_ad_revenue",
        "acc_iap_revenue",
        "dau",
        "play_time",
        "sessions",
        "ad_revenue",
        "iap_revenue",
        "ipm",
        "ecpm",
        "cti",
        "count_impression",
        "count_clicks",
        "ecpc",
        "daily_pu",
        "paid_rate",
        "au_daily_pu",
        "au_paid_rate",
        "ipdau",
        "rpdau",
        "iap_rpdau",
        "ad_rpdau",
        "rpm",
        "banner_ipdau",
        "banner_rpdau",
        "banner_rpm",
        "inter_ipdau",
        "inter_rpdau",
        "inter_rpm",
        "reward_ipdau",
        "reward_rpdau",
        "reward_rpm",
        "app_open_ipdau",
        "app_open_rpdau",
        "app_open_rpm",
        "native_ipdau",
        "native_rpdau",
        "native_rpm",
        "rewarded_inter_ipdau",
        "rewarded_inter_rpdau",
        "advertisingID",
        "predict",
    ]);

    const [columnOrder, setColumnOrder] = useState([
        "install_ad_network",
        "ltv_d1_2",
        "ltv_d3",
        "ltv_d7",
        "ltv_d15",
        "ltv_d30",
        "ad_ltv_d1",
        "ad_ltv_d3",
        "ad_ltv_d7",
        "iap_ltv_d1",
        "iap_ltv_d3",
        "iap_ltv_d7",
        "RR_D1",
        "RR_D3",
        "RR_D7",
        "RR_D15",
        "RR_D30",
        "acc_ad_revenue",
        "acc_iap_revenue",
        "dau",
        "play_time",
        "sessions",
        "ad_revenue",
        "iap_revenue",
        "ipm",
        "ecpm",
        "cti",
        "count_impression",
        "count_clicks",
        "ecpc",
        "daily_pu",
        "paid_rate",
        "au_daily_pu",
        "au_paid_rate",
        "ipdau",
        "rpdau",
        "iap_rpdau",
        "ad_rpdau",
        "rpm",
        "banner_ipdau",
        "banner_rpdau",
        "banner_rpm",
        "inter_ipdau",
        "inter_rpdau",
        "inter_rpm",
        "reward_ipdau",
        "reward_rpdau",
        "reward_rpm",
        "app_open_ipdau",
        "app_open_rpdau",
        "app_open_rpm",
        "native_ipdau",
        "native_rpdau",
        "native_rpm",
        "rewarded_inter_ipdau",
        "rewarded_inter_rpdau",
        "advertisingID",
    ]);

    const getFieldLabel = (field) => {
        const fieldMap = {
            install_ad_network: "Attributed Installs",
            ltv_d1_2:"LTV D1 2",
            ltv_d3:"LTV D3",
            ltv_d7:"LTV D7",
            ltv_d15:"LTV D15",
            ltv_d30:"LTV D30",
            ad_ltv_d1:"Ad LTV D1",
            ad_ltv_d3:"Ad LTV D3",
            ad_ltv_d7:"Ad LTV D7",
            iap_ltv_d1:"IAP LTV D1",
            iap_ltv_d3:"IAP LTV D3",
            iap_ltv_d7:"IAP LTV D7",
            RR_D1:"RR D1",
            RR_D3:"RR D3",
            RR_D7:"RR D7",
            RR_D15:"RR D15",
            RR_D30:"RR D30",
            acc_ad_revenue:"Acc. Ad Revenue",
            acc_iap_revenue:"Acc. IAP Revenuee",
            dau:"DAU",
            play_time:"Play Time",
            sessions:"Sessions",
            ad_revenue:"Ad Revenue",
            iap_revenue:"IAP Revenue",
            count_impression:"M-Impression",
            daily_pu:"Daily Paid Users",
            paid_rate:"Paid Rate",
            au_daily_pu:"AU Paid Users",
            au_paid_rate:"AU Paid Rate",
            ipdau:"IPDAU",
            rpdau:"RPDAU",
            iap_rpdau:"IAP RPDAU",
            ad_rpdau:"Ad RPDAU",
            rpm:"RPM",
            banner_ipdau:"Banner IPDAU",
            banner_rpdau:"Banner RPDAU",
            banner_rpm:"Banner RPM",
            inter_ipdau:"Inter. IPDAU",
            inter_rpdau:"Inter. RPDAU",
            inter_rpm:"Inter. RPM",
            reward_ipdau:"Reward. IPDAU",
            reward_rpdau:"Reward. RPDAU",
            reward_rpm:"Reward. RPM",
            app_open_ipdau:"App Open IPDAU",
            app_open_rpdau:"App Open RPDAU",
            app_open_rpm:"App Open RPM",
            native_ipdau:"Native. IPDAU",
            native_rpdau:"Native. RPDAU",
            native_rpm:"Native. RPM",
            rewarded_inter_ipdau:"Rewarded Inter. IPDAU",
            rewarded_inter_rpdau:"Rewarded Inter. RPDAU",
            advertisingID:"AdvertisingID %",
            predict:"Predict",
        };
        return fieldMap[field] || field;
    };

    const moveColumn = (from, to) => {

        let fromIndex = typeof from === "string" ? columnOrder.indexOf(from) : from;
        let toIndex = typeof to === "string" ? columnOrder.indexOf(to) : to;
        if (fromIndex < 0 || toIndex < 0) return;
        const newOrder = [...columnOrder];
        const [movedItem] = newOrder.splice(fromIndex, 1);
        newOrder.splice(toIndex, 0, movedItem);
        setColumnOrder(newOrder);
    };

    const [visibleColumns, setVisibleColumns] = useState({});

    const dataTotal = {};
    const sortedData = [];
    const METRIC_FORMATS = {};
    const toggleSort = () => {};
    const hasActiveFilter = () => false;
    const handleColumnFilterClick = (field, event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setColumnFilterPopup({ activeColumn: field, position: { top: rect.bottom, left: rect.left } });
    };
    const renderGroup = () => null;
    const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const updateCondition = () => {};
    const toggleFieldExpand = () => {};
    const setAllColumnsVisible = () => {};
    const renderFilterFieldControls = () => null;

    const handleMetricToggle = (metricId) => {

        setAnalyticsMetricsState((prev) =>
            prev.map((metric) =>
                metric.id === metricId
                    ? { ...metric, selected: !metric.selected }
                    : metric
            )
        );


        setAdFormatMetricsState((prev) =>
            prev.map((metric) =>
                metric.id === metricId
                    ? { ...metric, selected: !metric.selected }
                    : metric
            )
        );
    };

    const runReport = (data) => {
        console.log("Run Report:", data);
        setHasRunReportTop(true);
    };

    const setActiveCustomMetric = (idx) => {
        setCustomMetrics((prev) =>
            prev.map((m, i) => ({ ...m, active: i === idx ? !m.active : m.active }))
        );
    };

    const onOpenEditModal = (idx) => {
        setEditingIndex(idx);
        setEditVisible(true);
    };

    const availableMetrics = [
        { id: 'attributed_installs', label: 'Attributed Installs' },
        { id: 'ad_network_installs', label: 'Ad Network Installs' },
        { id: 'impressions', label: 'Impressions' },
        { id: 'clicks', label: 'Clicks' },
        { id: 'cost', label: 'Cost' },
        { id: 'revenue', label: 'Revenue' },
        { id: 'sessions', label: 'Sessions' },
        { id: 'dau', label: 'DAU' }
    ];

    const handleAddMetric = (metric) => {
        setSelectedMetrics(prev => [...prev, metric]);
        setShowMetricDropdown(false);
    };

    const handleAddOperator = (operator) => {
        setSelectedMetrics(prev => [...prev, { id: operator, label: operator }]);
    };

    const handleAddNumber = () => {
        if (numberInput.trim()) {
            setSelectedMetrics(prev => [...prev, { id: 'number', label: numberInput }]);
            setNumberInput('');
            setShowNumberInput(false);
        }
    };

    const handleRemoveMetric = (index) => {
        setSelectedMetrics(prev => prev.filter((_, i) => i !== index));
    };

    const handleClear = () => {
        if (selectedMetrics.length > 0) {
            setSelectedMetrics(prev => prev.slice(0, -1));
        }
    };

    const handleClearAll = () => {
        setSelectedMetrics([]);
    };
    const getVisibleColumns = () => columnOrder.filter((f) => visibleColumns[f] !== false);


    return (
        <>
            <div className="background-second-dashboard">
                <section className="main__content-dashbard">

                    <div className="container-fluid">
                        <h4><b>Mediation A/B Testing Report</b></h4>
                        <div className="card">
                            <div className="card-body">
                                <div className="tab-content" id="nav-tabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-home"
                                        role="tabpanel"
                                        aria-labelledby="nav-home-tab"
                                    >
                                        <div className="detail-body">
                                            <div className="overview_content pd-20">
                                                <div>
                                                    <div className="mb-6">
                                                        <FilterForm onSubmit={runReport} />
                                                    </div>
                                                    <div className="mb-6">
                                                        <Collapse
                                                            onChange={(keys) =>
                                                                setMetricsExpanded(keys?.includes("1"))
                                                            }
                                                        >
                                                            <Collapse.Panel
                                                                header={
                                                                    <span className="metrics-header">
                                                                        Metrics
                                                                    </span>
                                                                }
                                                                key="1"
                                                            >
                                                                <MetricsSection
                                                                    analyticsMetrics={analyticsMetricsState}
                                                                    adFormatMetrics={adFormatMetricsState}
                                                                    onMetricToggle={handleMetricToggle}
                                                                    rrDays={rrDays}
                                                                    setRrDays={setRrDays}
                                                                    iapDays={iapDays}
                                                                    setIapDays={setIapDays}
                                                                    adDays={adDays}
                                                                    setAdDays={setAdDays}
                                                                    ltvDays={ltvDays}
                                                                    setLtvDays={setLtvDays}
                                                                    customMetrics={customMetrics}
                                                                    setActiveCustomMetric={setActiveCustomMetric}
                                                                    onOpenEditModal={onOpenEditModal}
                                                                    setAddVisible={setAddVisible}
                                                                />
                                                                <AntButton
                                                                    type="primary"
                                                                    onClick={() => setHasRunReportMetrics(true)}
                                                                    className="run-report-btn"
                                                                >
                                                                    Run Report
                                                                </AntButton>
                                                            </Collapse.Panel>
                                                        </Collapse>
                                                    </div>
                                                </div>
                                            </div>
                                            {(hasRunReportTop || hasRunReportMetrics) && (
                                                <div className="table_overview_content pd-20">
                                                    <TableContainer
                                                        fields={fields}
                                                        getVisibleColumns={getVisibleColumns}
                                                        sortConfig={sortConfig}
                                                        toggleSort={toggleSort}
                                                        getFieldLabel={getFieldLabel}
                                                        hasActiveFilter={hasActiveFilter}
                                                        handleColumnFilterClick={handleColumnFilterClick}
                                                        sortedData={sortedData}
                                                        renderGroup={renderGroup}
                                                        dataTotal={dataTotal}
                                                        formatNumber={formatNumber}
                                                        METRIC_FORMATS={METRIC_FORMATS}
                                                        columnFilterPopup={columnFilterPopup}
                                                        columnPopupRef={columnPopupRef}
                                                        ColumnFilterPopupContent={() => null}
                                                        filters={filters}
                                                        updateCondition={updateCondition}
                                                        onCloseColumnFilterPopup={() => setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } })}
                                                        showPopup={showPopup}
                                                        togglePopup={() => setShowPopup((v) => !v)}
                                                        fieldsPanel={{}}
                                                        showFilterPanel={showFilterPanel}
                                                        setShowFilterPanel={setShowFilterPanel}
                                                        columnsPanel={{ searchTerm, setSearchTerm, columnOrder, setAllColumnsVisible, ColumnField: null }}
                                                        headerDrag={{ moveColumn }}
                                                        setFilters={setFilters}
                                                        filterableColumns={filterableColumns}
                                                        toggleFieldExpand={toggleFieldExpand}
                                                        renderFilterFieldControls={renderFilterFieldControls}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Modal
                            title="Update Custom Metric"
                            open={editVisible}
                            onCancel={() => setEditVisible(false)}
                            footer={[
                                <AntButton
                                    key="cancel"
                                    onClick={() => setEditVisible(false)}
                                >
                                    Cancel
                                </AntButton>,
                                <AntButton
                                    key="delete"
                                    danger
                                    style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f', color: '#fff' }}
                                    onClick={() => setEditVisible(false)}
                                >
                                    Delete
                                </AntButton>,
                                <AntButton
                                    key="update"
                                    type="primary"
                                    onClick={() => setEditVisible(false)}
                                >
                                    Update
                                </AntButton>,
                            ]}
                            width={600}
                        >
                            <div style={{ padding: '16px 0' }}>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Name:
                                    </label>
                                    <Input
                                        placeholder="Attributed / Ad Network Installs"
                                        style={{ width: '100%' }}
                                        disabled
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        Description:
                                    </label>
                                    <Input
                                        placeholder="Description"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Data format:
                                    </label>
                                    <Select
                                        defaultValue="Percent (%)"
                                        style={{ width: '100%' }}
                                        options={[{ value: "Percent (%)", label: "Percent (%)" }]}
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Title Color:
                                    </label>
                                    <Select
                                        defaultValue="Black"
                                        style={{ width: '100%' }}
                                        options={[
                                            {
                                                value: "Black",
                                                label: (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span>Black</span>
                                                        <div style={{ width: '12px', height: '12px', backgroundColor: '#000', borderRadius: '2px' }}></div>
                                                    </div>
                                                )
                                            }
                                        ]}
                                    />
                                </div>
                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Background Color:
                                    </label>
                                    <ColorPicker
                                        defaultValue="#000000"
                                        presets={[
                                            {
                                                label: 'Recommended',
                                                colors: [
                                                    '#000000',
                                                    '#ffffff',
                                                    '#ff4d4f',
                                                    '#1890ff',
                                                    '#52c41a',
                                                    '#faad14',
                                                    '#722ed1',
                                                    '#eb2f96',
                                                ],
                                            },
                                        ]}
                                    />
                                </div>

                                <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', gap: '8px', position: 'relative' }}>
                                        <div style={{ position: 'relative' }}>
                                            <AntButton
                                                type="text"
                                                size="small"
                                                style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#1890ff' }}
                                                onClick={() => setShowMetricDropdown(!showMetricDropdown)}
                                            >
                                                <PlusOutlined style={{ fontSize: '12px' }} />
                                                Add Metric
                                            </AntButton>
                                            {showMetricDropdown && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '-200px',
                                                    left: '0',
                                                    width: '200px',
                                                    backgroundColor: 'white',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '6px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}>
                                                    {availableMetrics.map((metric) => (
                                                        <div
                                                            key={metric.id}
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                fontSize: '14px'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                            onClick={() => handleAddMetric(metric)}
                                                        >
                                                            {metric.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                            {showNumberInput ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <Input
                                                        value={numberInput}
                                                        onChange={(e) => setNumberInput(e.target.value)}
                                                        placeholder="Number"
                                                        style={{ width: '120px' }}
                                                        onPressEnter={handleAddNumber}
                                                        autoFocus
                                                    />
                                                    <span
                                                        style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
                                                        onClick={() => {
                                                            setShowNumberInput(false);
                                                            setNumberInput('');
                                                        }}
                                                    >
                      ×
                    </span>
                                                    <span
                                                        style={{ cursor: 'pointer', color: '#52c41a', fontSize: '16px' }}
                                                        onClick={handleAddNumber}
                                                    >
                      ✓
                    </span>
                                                </div>
                                            ) : (
                                                <span
                                                    style={{ color: '#666', fontSize: '14px', cursor: 'pointer' }}
                                                    onClick={() => setShowNumberInput(true)}
                                                >
                    Number
                  </span>
                                            )}
                                        </div>

                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('(')}
                                        >
                                            (
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator(')')}
                                        >
                                            )
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('+')}
                                        >
                                            +
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('-')}
                                        >
                                            -
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('X')}
                                        >
                                            X
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('÷')}
                                        >
                                            ÷
                                        </AntButton>

                                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                                            <AntButton
                                                type="link"
                                                size="small"
                                                style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </AntButton>
                                            <AntButton
                                                type="link"
                                                size="small"
                                                style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                                                onClick={handleClearAll}
                                            >
                                                Clear All
                                            </AntButton>
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: '12px',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: '6px',
                                        backgroundColor: '#fafafa',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    }}>
                                        {selectedMetrics.length === 0 ? (
                                            <span style={{ color: '#999', fontStyle: 'italic' }}>Formula will be show here</span>
                                        ) : (
                                            selectedMetrics.map((metric, index) => {

                                                const isOperator = ['(', ')', '+', '-', 'X', '÷', 'number'].includes(metric.id);

                                                return (
                                                    <div key={index} style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        backgroundColor: isOperator ? '#f0f0f0' : '#e6f7ff',
                                                        border: isOperator ? '1px solid #d9d9d9' : '1px solid #91d5ff',
                                                        borderRadius: '16px',
                                                        padding: '2px 8px',
                                                        fontSize: '12px',
                                                        gap: '4px'
                                                    }}>
                                                        <span>{metric.label}</span>
                                                        {!isOperator && (
                                                            <span
                                                                style={{ cursor: 'pointer', color: '#666' }}
                                                                onClick={() => handleRemoveMetric(index)}
                                                            >
                          ×
                        </span>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        {/* Add Custom Metric Modal */}
                        <Modal
                            title="Add Custom Metric"
                            open={addVisible}
                            onCancel={() => setAddVisible(false)}
                            footer={[
                                <AntButton
                                    key="cancel"
                                    onClick={() => setAddVisible(false)}
                                >
                                    Cancel
                                </AntButton>,
                                <AntButton
                                    key="add"
                                    type="primary"
                                    onClick={() => {

                                        const newMetric = {
                                            label: "New Custom Metric",
                                            active: false
                                        };
                                        setCustomMetrics(prev => [...prev, newMetric]);
                                        setAddVisible(false);
                                    }}
                                >
                                    Add
                                </AntButton>,
                            ]}
                            width={600}
                        >
                            <div style={{ padding: '16px 0' }}>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Name:
                                    </label>
                                    <Input
                                        placeholder="Enter metric name"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        Description:
                                    </label>
                                    <Input
                                        placeholder="Description"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Data format:
                                    </label>
                                    <Select
                                        defaultValue="Percent (%)"
                                        style={{ width: '100%' }}
                                        options={[{ value: "Percent (%)", label: "Percent (%)" }]}
                                    />
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Title Color:
                                    </label>
                                    <Select
                                        defaultValue="Black"
                                        style={{ width: '100%' }}
                                        options={[
                                            {
                                                value: "Black",
                                                label: (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span>Black</span>
                                                        <div style={{ width: '12px', height: '12px', backgroundColor: '#000', borderRadius: '2px' }}></div>
                                                    </div>
                                                )
                                            }
                                        ]}
                                    />
                                </div>
                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <span style={{ color: '#ff4d4f' }}>*</span> Background Color:
                                    </label>
                                    <ColorPicker
                                        defaultValue="#000000"
                                        presets={[
                                            {
                                                label: 'Recommended',
                                                colors: [
                                                    '#000000',
                                                    '#ffffff',
                                                    '#ff4d4f',
                                                    '#1890ff',
                                                    '#52c41a',
                                                    '#faad14',
                                                    '#722ed1',
                                                    '#eb2f96',
                                                ],
                                            },
                                        ]}
                                    />
                                </div>

                                <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', gap: '8px', position: 'relative' }}>
                                        <div style={{ position: 'relative' }}>
                                            <AntButton
                                                type="text"
                                                size="small"
                                                style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#1890ff' }}
                                                onClick={() => setShowMetricDropdown(!showMetricDropdown)}
                                            >
                                                <PlusOutlined style={{ fontSize: '12px' }} />
                                                Add Metric
                                            </AntButton>
                                            {showMetricDropdown && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '-200px',
                                                    left: '0',
                                                    width: '200px',
                                                    backgroundColor: 'white',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '6px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}>
                                                    {availableMetrics.map((metric) => (
                                                        <div
                                                            key={metric.id}
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                fontSize: '14px'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                            onClick={() => handleAddMetric(metric)}
                                                        >
                                                            {metric.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                            {showNumberInput ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <Input
                                                        value={numberInput}
                                                        onChange={(e) => setNumberInput(e.target.value)}
                                                        placeholder="Number"
                                                        style={{ width: '120px' }}
                                                        onPressEnter={handleAddNumber}
                                                        autoFocus
                                                    />
                                                    <span
                                                        style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
                                                        onClick={() => {
                                                            setShowNumberInput(false);
                                                            setNumberInput('');
                                                        }}
                                                    >
                                          ×
                                        </span>
                                                    <span
                                                        style={{ cursor: 'pointer', color: '#52c41a', fontSize: '16px' }}
                                                        onClick={handleAddNumber}
                                                    >
                                          ✓
                                        </span>
                                                </div>
                                            ) : (
                                                <span
                                                    style={{ color: '#666', fontSize: '14px', cursor: 'pointer' }}
                                                    onClick={() => setShowNumberInput(true)}
                                                >
                                        Number
                                      </span>
                                            )}
                                        </div>

                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('(')}
                                        >
                                            (
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator(')')}
                                        >
                                            )
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('+')}
                                        >
                                            +
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('-')}
                                        >
                                            -
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('X')}
                                        >
                                            X
                                        </AntButton>
                                        <AntButton
                                            type="text"
                                            size="small"
                                            style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                                            onClick={() => handleAddOperator('÷')}
                                        >
                                            ÷
                                        </AntButton>

                                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                                            <AntButton
                                                type="link"
                                                size="small"
                                                style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </AntButton>
                                            <AntButton
                                                type="link"
                                                size="small"
                                                style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                                                onClick={handleClearAll}
                                            >
                                                Clear All
                                            </AntButton>
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: '12px',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: '6px',
                                        backgroundColor: '#fafafa',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    }}>
                                        {selectedMetrics.length === 0 ? (
                                            <span style={{ color: '#999', fontStyle: 'italic' }}>Formula will be show here</span>
                                        ) : (
                                            selectedMetrics.map((metric, index) => {

                                                const isOperator = ['(', ')', '+', '-', 'X', '÷', 'number'].includes(metric.id);

                                                return (
                                                    <div key={index} style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        backgroundColor: isOperator ? '#f0f0f0' : '#e6f7ff',
                                                        border: isOperator ? '1px solid #d9d9d9' : '1px solid #91d5ff',
                                                        borderRadius: '16px',
                                                        padding: '2px 8px',
                                                        fontSize: '12px',
                                                        gap: '4px'
                                                    }}>
                                                        <span>{metric.label}</span>
                                                        {!isOperator && (
                                                            <span
                                                                style={{ cursor: 'pointer', color: '#666' }}
                                                                onClick={() => handleRemoveMetric(index)}
                                                            >
                          ×
                        </span>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </section>
            </div>
        </>
    );
}

export default AppMediation;